/*
import { useTheme } from '@mui/material/styles';
import ExitButton from 'components/button/ExitButton';
import ComptrollerIcon from 'assets/icons/comptroller';
import ScreenMenu from 'components/dropdown/ScreenMenu';
import { Box, DialogTitle, useMediaQuery } from '@mui/material';

const ViewEditModalHeader = ({ isScreenSize = true, screenSize, setScreenSize, type = 'View', viewType = true, headerTitle, handleClose }) => {
	const theme = useTheme();
	const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

	return (
		<Box
			sx={{
				height: '48px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				borderBottom: `1px solid ${theme.palette.divider}`,
				background: type === 'View' ? 'linear-gradient(90deg, #155DFC 0%, #1447E6 100%)' : '#00914F',
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<DialogTitle
					sx={{
						py: 0,
						gap: '8px',
						display: 'flex',
						height: '48px',
						fontSize: '16px',
						alignItems: 'center',
						color: 'common.white',
						fontWeight: '600 !important',
					}}
				>
					{icon ? icon : <ComptrollerIcon width="20px" height="20px" color="#fff" />}
					{viewType && type} {headerTitle}
				</DialogTitle>
			</Box>

			<Box sx={{ mr: 3, display: 'flex', alignItems: 'center', gap: '12px' }}>
				{isScreenSize && (
					<Box sx={{ borderRadius: '4px', padding: '2px 12px' }}>
						{!matchDownMD && <ScreenMenu screenSize={screenSize} setScreenSize={setScreenSize} />}
					</Box>
				)}

				<ExitButton handleClose={handleClose} />
			</Box>
		</Box>
	);
};

export default ViewEditModalHeader;
*/

import ExitButton from 'components/button/ExitButton';
import ScreenMenu from 'components/dropdown/ScreenMenu';
import { Box, DialogTitle, useMediaQuery } from '@mui/material';

const ViewEditModalHeader = ({ isScreenSize = true, screenSize, setScreenSize, type = 'View', viewType = true, icon, headerTitle, handleClose }) => {
	const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
	const normalizedType = String(type || '').toLowerCase();
	const isEditMode = normalizedType === 'edit';

	return (
		<Box
			sx={{
				height: '46px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				backgroundColor: isEditMode ? '#FFF7ED' : '#F8FAFC',
				borderTopLeftRadius: '12px',
				borderTopRightRadius: '12px',
				borderBottom: `1px solid ${isEditMode ? '#FED7AA' : '#E2E8F0'}`,
			}}
		>
			<DialogTitle
				sx={{
					py: 0,
					px: 2,
					gap: 1,
					display: 'flex',
					height: '46px',
					fontSize: '16px',
					alignItems: 'center',
					color: isEditMode ? '#9A3412' : '#0F172A',
					fontWeight: 600,
				}}
			>
				{viewType && type} {headerTitle}
			</DialogTitle>

			<Box sx={{ pr: 2, display: 'flex', alignItems: 'center', gap: '20px' }}>
				{isScreenSize && !matchDownMD && (
					<ScreenMenu screenSize={screenSize} setScreenSize={setScreenSize} iconColor="#475569" activeBorderColor="#475569" />
				)}
				<ExitButton handleClose={handleClose} color="#64748B" />
			</Box>
		</Box>
	);
};

export default ViewEditModalHeader;
